import { FieldErrors } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '../types';
import { useEffect } from 'react';

export const useScrollToError = (
  isSubmitted: boolean,
  errors: FieldErrors<TPurposeOfBusinessRelations>
) => {
  useEffect(() => {
    if (!isSubmitted || !errors) return;
    const parentName = Object.keys(errors)[0];
    const item = errors?.[parentName as keyof typeof errors];
    if (!item) return;
    let errorName;
    if (
      Array.isArray(item) &&
      !['explanation', 'licenses'].some((item) => parentName?.includes(item))
    ) {
      const index = item.findIndex((item) => item && Object.keys(item)?.length !== 0);
      errorName = `${parentName}.${index}`;
    } else {
      errorName = parentName;
    }

    if (!errorName) return;

    const el = document.querySelector(
      `[name="${errorName}"], [data-name="${errorName}"]`
    ) as HTMLElement | null;

    el?.scrollIntoView({
      block: 'center',
    });

    el?.focus?.();
  }, [isSubmitted, errors]);
};
